<template>
  <div
    class="border border-[#eceef0] rounded-[18px] mb-4"
    style="border-width: 1.5px"
  >
    <div
      v-if="label"
      class="px-4 py-[7px] border-b border-[#eceef0] bg-[#f2f4f6] rounded-t-[17px]"
    >
      <span
        class="font-[Poppins] font-bold text-[10px] text-[#6c7a77] tracking-[1px] uppercase"
        >{{ label }}</span
      >
    </div>
    <div
      class="flex flex-wrap items-center gap-4 px-6 py-7"
      :style="{ backgroundColor: bg }"
    >
      <slot />
    </div>
  </div>
</template>

<script setup>
defineProps({ label: String, bg: { type: String, default: "#f8fafa" } });
</script>
